<template>
  <div class="password-recovery">
    <RegAuthForgotTitle no-logo :name="pageName" />
    <div v-if="!get_resultPasswordChange" class="password-recovery__form">
      <RegAuthForgotTabs v-if="isShowTabs" class="password-recovery__tabs" />
      <PasswordRecoveryForm />
    </div>
    <div v-else class="password-recovery__form">
      <div class="password-recovery__title">
        <SvgIcon
          name="common/warning"
          class="password-recovery__icon"
        />
        <UiText
          font="body-h2"
          color="typography-title01"
          :text="$tc('regAuthForgot.passwordChangeForm.infoTitle')"
        />
      </div>
      <UiText
        :text="$tc('regAuthForgot.passwordChangeForm.infoText')"
        font="body-text-small"
        color="typography-body01"
        class="password-recovery__description"
      />
      <PasswordChangeForm class="password-recovery__password-form" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegAuthForgotTitle from '@/components/BigModal/RegAuthForgot/RegAuthForgotTitle'
import RegAuthForgotTabs from '@/components/BigModal/RegAuthForgot/RegAuthForgotTabs'
import PasswordRecoveryForm from '@/components/Forms/PasswordRecoveryForm'
import PasswordChangeForm from '@/components/Forms/PasswordChangeForm'

export default {
  name: 'PasswordRecovery',
  components: {
    RegAuthForgotTabs,
    PasswordRecoveryForm,
    PasswordChangeForm,
    RegAuthForgotTitle,
  },
  data() {
    return {
      isPasswordRecoveryInitByEmailToken: false,
    }
  },
  computed: {
    ...mapGetters('login', ['get_resultPasswordRequest', 'get_resultPasswordChange']),
    pageName() {
      return this.$route.query.bigModal || 'registration'
    },
    isShowTabs() {
      return !this.get_resultPasswordRequest && !this.isPasswordRecoveryInitByEmailToken
    },
  },
  created() {
    if (process.server) return
    this.isPasswordRecoveryInitByEmailToken = !!this.$route.query.token
  },
  beforeDestroy() {
    this.act_resultPasswordRequest(false)
    this.act_resultPasswordChange(false)
  },
  methods: {
    ...mapActions('login', ['act_resultPasswordRequest', 'act_resultPasswordChange']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
